<template>
  <div class="appconfigXh height100">
    <el-container direction="vertical" class="height100" ref="appconMain" v-if="!rolePermissionVisible">
      <p  class=" smallHeader" ref="baseheader">{{$t('basic_software_config')}}</p>
      <div ref="headerCon"> <!-- class="height40" -->
        <!-- <el-checkbox v-model="systemApps.pmEnable" @change="onSystemAppConfigChange('pm')">启用任务管理软件</el-checkbox>-->
        <!-- 调查问卷 -->
        <!-- <el-checkbox v-if="isSuper" v-model="systemApps.qmEnable" @change="onSystemAppConfigChange('qm')">{{$t('qmEnable')}}</el-checkbox>  -->
        <!-- <el-checkbox v-if="isSuper" v-model="systemApps.amEnable" @change="onSystemAppConfigChange('am')">启用微考勤软件</el-checkbox> -->
        <!-- 联系人 -->
        <!-- <el-checkbox v-if="isSuper" v-model="systemApps.cmEnable" @change="onSystemAppConfigChange('cm')" size="small">{{$t('cmEnable')}}</el-checkbox> -->
        <!-- 流程中心 -->
        <el-checkbox v-model="systemApps.pcmEnable" @change="onSystemAppConfigChange('pcm')" size="small">{{$t('pcmEnable')}}</el-checkbox>
        <!-- 知识文档 -->
        <el-checkbox v-if="isSuper" v-model="systemApps.kmEnable" @change="onSystemAppConfigChange('km')" size="small">{{$t('kmEnable')}}</el-checkbox>
        <el-checkbox v-model="systemApps.kmTeamEnable" @change="onSystemAppConfigChange('kmTeam')" size="small" v-if="systemApps.kmEnable">{{$t('kmTeamEnable')}}</el-checkbox>
        <el-checkbox v-model="systemApps.kmRealmEnable" @change="onSystemAppConfigChange('kmRealm')" size="small" v-if="systemApps.kmEnable">{{$t('kmRealmEnable')}}</el-checkbox>
        
        <el-button type="primary" @click="onBindKMRole" size="small" plain class="marginLeft10" v-if="systemApps.kmEnable">{{$t('km_role')}}</el-button>
        <kmrolemanager :visible.sync="showKMRoleManagerDlg" v-if="showKMRoleManagerDlg"/>
      </div>
      <el-row class="customapp-title" ref="smallHeader">
        <el-col :span="12"><p class=" smallHeader">{{$t('custom_software')}}</p></el-col>
        <el-col :span="12" class="align-right">
          <el-button v-if="isSuper" @click="onUnbindCustomApps" size="small" type="danger" plain>{{$t('remove')}}</el-button>
          <el-button v-if="isSuper" type="primary" @click="onBindCustomApps" size="small">{{$t('add')}}</el-button>
        </el-col>
      </el-row>
      <el-row>
          <el-col :span="12">
            <el-form :inline="true" :model="searchdata" class="form-inline" size="mini" @submit.native.prevent>
              <el-form-item >
                <el-input v-model="searchdata.name" :placeholder="$t('software_name')" @keyup.enter.native="searchTableData"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button @click="searchTableData" type="primary" plain>{{$t('query')}}</el-button>
                <el-button @click="resetSearchTableData">{{$t('reset')}}</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>

      <el-table 
      :data="customApps.datas" 
      @selection-change="onSelectionChange"
      header-cell-class-name="tableHeaderbg" 
      stripe 
      size="small"
      :height="tableListConHeight"
      class="overflowYScroll">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" :label="$t('software_name')" width="180"></el-table-column>
        <el-table-column :label="$t('mode')" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.type == 0 ? $t('regular_mode') : $t('platform_mode') }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="description" :label="$t('description')" width="180"></el-table-column>
        <el-table-column :label="$t('fettle')">
          <template slot-scope="scope">{{scope.row.activated? $t('active') : $t('inactive')}}</template>
        </el-table-column>
        <el-table-column :label="$t('operating')">
          <template slot-scope="scope">
            <el-button v-if="scope.row.type == 0" @click.stop="rolePermission(scope.row)" type="primary" plain size="mini" >{{$t('add_role')}}</el-button>
            <el-button v-if="scope.row.type == 1" @click.stop="onBpmModeConf(scope.row)" type="primary" plain size="mini" >{{$t('bpm_Mode_Conf')}}</el-button>
          </template>
        </el-table-column>
        <el-table-column :label="$t('export_operation')">
          <template slot-scope="scope">
            <el-button @click.stop="exportrolemenuauthority(scope.row)" type="primary" plain size="mini" >{{$t('role_menu')}}</el-button>
            <el-button @click.stop="exportroleuserauthority(scope.row)" type="primary" plain size="mini" >{{$t('role_user')}}</el-button>

          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currpage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagelines"
          layout="prev, pager, next, total, sizes"
          background
          :total="customApps.rowCount"
        ></el-pagination>
    </el-container>
    <el-container direction="vertical" class="height100" ref="appconMain" v-if="rolePermissionVisible">
      <roleList  :applicationId="applicationId" @exit="onExit"></roleList>
    </el-container>
    <appconfig_add :visible.sync="showAddCustomAppDlg" @refresh="initAppConfig" v-if="showAddCustomAppDlg" />
    <bpm_dialog  :visible.sync="showBpmModeDlg" :selectedApp="applicationId" :selectedAppName='selectedAppName' v-if="showBpmModeDlg" />
  </div>
</template>

<script>
import appconfig_add from "@/components/appconfig_add.vue";
import kmrolemanager from "@/components/kmrolemanager.vue";
import roleList from "@/components/roleList.vue";
import bpm_dialog from "@/components/bpm_dialog.vue";

export default {
  components: {
    appconfig_add,
    kmrolemanager,
    roleList,
    bpm_dialog
  },
  data() {
    return {
      systemApps: {},
      customApps: {},
      showAddCustomAppDlg: false,
      showBpmModeDlg: false,
      showKMRoleManagerDlg: false,
      multipleSelection: [],
      searchdata:{
        name:"",
      },
      tableListConHeight:null,
      rolePermissionVisible:false,
      applicationId:'',
      selectedAppName:'',
      currpage: 1,
      pagelines: 10,
      isSuper: "" //是否是管理员
    };
  },
  created() {
    this.isSuper = this.$store.state.currentUser.type=="super"?true:false;
    console.log(this.isSuper)
    this.initAppConfig();
  },
  mounted(){
    this.tableListConHeight=this.$refs.appconMain.$el.getClientRects()[0].height-this.$refs.baseheader.getClientRects()[0].height+20-this.$refs.headerCon.getClientRects()[0].height-this.$refs.smallHeader.$el.getClientRects()[0].height;
  },
  methods: {
    /**
     * 导出操作-角色和菜单
     */
    exportrolemenuauthority(row){
      this.$api.exportrolemenuauthority(row.id);
    },
    /**
     * 导出操作-角色和用户
     */
    exportroleuserauthority(row){
      this.$api.exportroleuserauthority(row.id, this.$route.query.domainid);
    },
    resetSearchTableData(){
      this.searchdata.name="";
      this.currpage = 1;
      this.pagelines = 10;
      this.searchTableData();
    },
    onExit(){
      this.rolePermissionVisible=false;
    },
    rolePermission(row){
      this.applicationId=row.id;
      this.rolePermissionVisible=true;
    },
    onBpmModeConf(row){
      this.applicationId=row.id;
      this.selectedAppName=row.name;
      this.showBpmModeDlg = true;
    },
    onBindCustomApps() {
      this.showAddCustomAppDlg = true;
    },
    onBindKMRole(){
      this.showKMRoleManagerDlg = true;
    },
    onSelectionChange(rows) {
      this.multipleSelection = rows;
    },
    // 每页条数
    handleSizeChange(size){
      this.pagelines=size;
      this.searchTableData();
    },
    // 当前页
    handleCurrentChange(val){
      this.currpage=val;
      this.searchTableData();
    },
    

    onUnbindCustomApps() {
      if(this.multipleSelection.length<=0){
        this.$message({
          showClose: true,
          message: this.$t('msg_select_software'),
          type: "error"
        });
        return false;
      }
      let ids = [];
      
      this.multipleSelection.forEach(row => {
        ids.push(row.id);
      });
      this.$api.unbindCustomApps(
        { domainid: this.$route.query.domainid, data: ids },
        {
          onSucess: resp => {
            if (resp.data.errcode == 0) {
              this.$message({
                showClose: true,
                message: this.$t('msg_remove_success'),
                type: "success"
              });
              this.initAppConfig();
            } else {
              this.$message({
                showClose: true,
                message: resp.data.errmsg,
                type: "error"
              });
            }
          }
        }
      );
    },

    initAppConfig() {
      this.$api.getSystemAppConfig(
        { domainid: this.$route.query.domainid },
        {
          onSucess: resp => {
            this.systemApps = resp.data.data||{};//没有data默认返回空对象
          }
        }
      );
      this.searchTableData();
    },
    searchTableData(){
      this.$api.getCustomAppConfig(
        { domainid: this.$route.query.domainid, data:{name: this.searchdata.name}, currpage: this.currpage, pagelines: this.pagelines  },
        {
          onSucess: resp => {
            this.customApps = resp.data.data||{};
          }
        }
      );
    },
    onSystemAppConfigChange(model) {
      let enable = false;
      switch (model) {
        case "pm":
          enable = this.systemApps.pmEnable;
          break;
        case "qm":
          enable = this.systemApps.qmEnable;
          break;
        case "am":
          enable = this.systemApps.amEnable;
          break;
        case "cm":
          enable = this.systemApps.cmEnable;
          break;
        case "pcm":
          enable = this.systemApps.pcmEnable;
          break;
        case "km":
          enable = this.systemApps.kmEnable;
          if(enable==false){
            this.systemApps.kmTeamEnable=false;
            this.systemApps.kmRealmEnable=false;
          }
          break;
        case "kmTeam":
          enable = this.systemApps.kmTeamEnable;
          break;
        case "kmRealm":
          enable = this.systemApps.kmRealmEnable;
          break;
      }

      if (enable) {
        this.$api.enableSystemApplicationConfig(
          { domainid: this.$route.query.domainid, module: model },
          {
            onSucess: resp => {
              if (resp.data.errcode == 0) {
                this.$message({
                  showClose: true,
                  message: this.$t('msg_save_success'),
                  type: "success"
                });
              } else {
                this.$message({
                  showClose: true,
                  message: resp.data.errmsg,
                  type: "error"
                });
              }
            }
          }
        );
      } else {
        this.$api.disableSystemApplicationConfig(
          { domainid: this.$route.query.domainid, module: model },
          {
            onSucess: resp => {
              if (resp.data.errcode == 0) {
                this.$message({
                  showClose: true,
                  message: this.$t('msg_save_success'),
                  type: "success"
                });
              } else {
                this.$message({
                  showClose: true,
                  message: resp.data.errmsg,
                  type: "error"
                });
              }
            }
          }
        );
      }
    }
  }
};
</script>

<style>
</style>